/* Custom dev */
(function ($) {
    // writes the string
    //
    // @param jQuery $target
    // @param String str
    // @param Numeric cursor
    // @param Numeric type_speed
    // @param Function cb
    // @return void
    function typeString($target, str, cursor, type_speed, cb) {
        $target.html(function (_, html) {
            return html + str[cursor];
        });

        if (cursor < str.length - 1) {
            setTimeout(function () {
                typeString($target, str, cursor + 1, type_speed, cb);
            }, type_speed);
        }
        else {
            cb();
        }
    }

    // clears the string
    //
    // @param jQuery $target
    // @param Numeric type_speed
    // @param Function cb
    // @return void
    function deleteString($target, type_speed, cb) {
        let length;

        $target.html(function (_, html) {
            length = html.length;
            return html.substr(0, length - 1);
        });

        if (length > 1) {
            setTimeout(function () {
                deleteString($target, type_speed, cb);
            }, type_speed);
        }
        else {
            cb();
        }
    }

    // jQuery hook
    $.fn.extend({
        teletype: function (opts) {
            const settings = $.extend({}, $.teletype.defaults, opts);

            return $(this).each(function () {
                let $this = $(this);
                setTimeout(function () {
                    (function loop($tar, idx) {
                        // type
                        typeString($tar, settings.text[idx], 0, settings.type_speed, function () {
                            // delete
                            setTimeout(function () {
                                deleteString($tar, settings.type_speed, function () {
                                    setTimeout(function () {
                                        loop($tar, (idx + 1) % settings.text.length);
                                    }, settings.before_type_pause);
                                });
                            }, settings.after_type_pause);
                        });

                    }($this, 0));
                }, settings.before_type_pause);
            });
        }
    });

    // plugin defaults
    $.extend({
        teletype: {
            defaults: {
                type_speed: 100,
                before_type_pause: 400,
                after_type_pause: 5000,
                text: []
            }
        }
    });
}(jQuery));